module.exports = __webpack_public_path__ + "img/failed.fa0d833b.svg";